$.fn.WeightCalc = function()
{
	var self = this;
	self.field = self.find("input[name=weight]");
	self.weight_unit = self.find("input[name=weight_unit]").val();
	self.weight_value = asFloat(self.find("input[name=weight]").val());

	self.toLbs = function()
	{
		if (self.weight_unit == "kg")
		{
			// update interface
			self.weight_unit = "lbs";
			self.find("#weight-unit-button").html(self.weight_unit);
			self.find("input[name=weight_unit]").val(self.weight_unit);

			// update value
			if (!isNaN(self.weight_value)){
				self.weight_value *= 2.20462262;
				self.find("input[name=weight]").val(Math.round(self.weight_value));
			}
		}
	};

	self.toKg = function()
	{
		if (self.weight_unit == "lbs")
		{
			// update interface
			self.weight_unit = "kg";
			self.find("#weight-unit-button").html(self.weight_unit);
			self.find("input[name=weight_unit]").val(self.weight_unit);

			// update value
			if (!isNaN(self.weight_value)){
				self.weight_value /= 2.20462262;
				self.find("input[name=weight]").val(Math.round(self.weight_value));
			}
		}
	};

	return function()
	{
		self.field.mask('999');
		self.find(".action-convert-weight-field-to-lbs").on("click", self.toLbs);
		self.find(".action-convert-weight-field-to-kg").on("click", self.toKg);
		self.find("input[name=weight]").on("change", function(){
			self.weight_value = asFloat(self.field.val());
			if (isNaN(self.weight_value)){
				self.weight_value = 0;
			}
		});
		return self;
	}();
};

$.fn.HeightCalc = function()
{
	var self = this;
	self.field = self.find("input[name=height]");
	self.height_unit = self.find("input[name=height_unit]").val();
	self.height_value = self.find("input[name=height_value]").val();

	self.prepareField = function()
	{
		if (self.height_unit == "pi"){
			self.field.mask('0\'09').attr("placeholder", "_'__");
		} else {
			self.field.mask('9.99').attr("placeholder", "_.__");
		}
	};

	self.toPi = function()
	{
		if (self.height_unit == "m")
		{
			// update interface
			self.height_unit = "pi";
			self.find("#height-unit-button").html(self.height_unit);
			self.find("input[name=height_unit]").val(self.height_unit);

			// get value
			var currentValue = asFloat(self.field.val());
			if (!isNaN(currentValue)){
				var inches = Math.round(Math.round(currentValue * 100) * 0.3937),
				feet = Math.floor(inches/12);
				self.weight_value = feet+"'"+(inches%12);
				self.find("input[name=height]").val(self.weight_value);
			}

			// prepare field
			self.prepareField();
		}
	};

	self.toM = function()
	{
		if (self.height_unit == "pi")
		{
			// update interface
			self.height_unit = "m";
			self.find("#height-unit-button").html(self.height_unit);
			self.find("input[name=height_unit]").val(self.height_unit);

			// get value
			var currentValue = parseFloat(self.field.val().replace("'", "."));
			if (!isNaN(currentValue)){
				var inches = Math.floor(currentValue) * 12 + ((currentValue - Math.floor(currentValue)) * 10),
				meters = Math.round(inches / 0.3937) / 100;
				self.weight_value = meters;
				self.find("input[name=height]").val(self.weight_value);
			}

			// prepare field
			self.prepareField();
		}
	};

	return function()
	{
		self.prepareField();
		self.field.on("blur", self.blurField);
		self.find(".action-convert-height-field-to-pi").on("click", self.toPi);
		self.find(".action-convert-height-field-to-m").on("click", self.toM);
		return self;
	}();
};

$.fn.ContactForm = function()	// extends Form
{
	_form = this;
	_form.uploader = {
		files: undefined,
		notes: undefined,
	};

	_form.get_contact_id = function()
	{
		return parseInt(_form.find("input[name=id]").val(), 10);
	};

	_form.init_permissions = function() {
		let initiallyDisabled = []
		$('input[name*="[write]"]').each(function() {
			if ($(this).prop('disabled')) {
				initiallyDisabled.push(this.name)
			}
		})
		$('input[name*="[read]"]').on('change', function() {
			const isChecked = $(this).is(':checked'),
			baseName = $(this).attr('name').replace('[read]', '')
			writeCheckbox = $('input[name="' + baseName + '[write]"]')
			if (!isChecked) {
				writeCheckbox.prop('checked', false).prop('disabled', true)
			} else {
				const writeName = writeCheckbox.attr('name')
				if (initiallyDisabled.indexOf(writeName) === -1) {
					writeCheckbox.prop('disabled', false)
				}
			}
		}).trigger('change')

		// Logique pour dépôts: nécessite tous les types de factures
		function checkDepositAccess() {
			const invoicePubChecked = $('input[name="permissions[invoice_pub][read]"]').is(':checked')
			const invoiceTvChecked = $('input[name="permissions[invoice_tv][read]"]').is(':checked')
			const invoiceProdChecked = $('input[name="permissions[invoice_prod][read]"]').is(':checked')
			const allInvoicesChecked = invoicePubChecked && invoiceTvChecked && invoiceProdChecked

			const depositRead = $('input[name="permissions[deposit][read]"]')
			const depositWrite = $('input[name="permissions[deposit][write]"]')

			if (!allInvoicesChecked) {
				depositRead.prop('checked', false).prop('disabled', true)
				depositWrite.prop('checked', false).prop('disabled', true)
				depositRead.closest('tr').css('opacity', '0.5')
			} else {
				depositRead.prop('disabled', false)
				depositWrite.prop('disabled', false)
				depositRead.closest('tr').css('opacity', '1')
			}
		}

		// Vérifier au chargement et sur changement des factures
		$('.invoice-type-checkbox').on('change', checkDepositAccess)
		checkDepositAccess()
	}

	_form.set_permissions = function() {
		var role = _form.find('#field-user-auth_level option:selected').text().toLowerCase();
		if (role == 'employé') {
			role = 'employee'
		}
		if (role == 'artiste') {
			_form.find('input[name="permissions[contact][read]"]').prop('checked', true).prop('disabled', true)
		} else {
			_form.find('input[name="permissions[contact][read]"]').prop('disabled', false)
		}
		var table = _form.find('table.table');
		var tableRoles = (table.data('roles')||'').split(',');
		if (tableRoles.indexOf(role) > -1) table.show();
		else table.hide();
		table.find('tbody tr').each(function() {
			var row = $(this);
			var roles = (row.data('roles')||'').split(',');
			if (roles.indexOf(role) > -1) row.show();
			else row.hide();
		});
	}

	return function()
	{
		/* Password generation */
		$("button#generate-password").on("click", function(){
			var field = $("#" + $(this).data("controls"));
			field.password('hide').password('val', generatePassword());
		});

		/* Password visibility */
		_form.find('input[type=password][data-toggle="password-custom"]').password({
			eyeClass: '',
			eyeOpenClass: 'icmn-eye',
			eyeCloseClass: 'icmn-eye-blocked'
		});

		/* Dropify elements for file inputs */
		_form.find('input[type=file].dropify').each(function(){
			var dropify_element = $('input[type=file]').dropify({
				messages: {
					default: 'Glissez un fichier ici ou cliquez pour sélectionner',
					replace: 'Glissez un fichier ou cliquez pour remplacer',
					remove:  'Supprimer',
					error:   'Désolé, le fichier est trop volumineux'
				}
			});
			dropify_element.on('dropify.afterClear', function(event, element){
				var field_name = dropify_element.data("edit-field-name");
				$("input[name=" + field_name + "]").val("");
			});
			$(this).on("change", function(){
				var field_name = dropify_element.data("edit-field-name");
				$("input[name=" + field_name + "]").val("");
			});
			_form.interface.dropify_elements.push(dropify_element);
		});

		/* Weight field */
		_form.find("#weight-calc").WeightCalc();

		/* Height field */
		_form.find("#height-calc").HeightCalc();

		/* Year / month picker */
		_form.find('input[name=passport_expire_date]').each(function(){
			var field = $(this);
			field.datetimepicker({
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				viewMode: 'years',
				format: 'MM/YYYY',
				locale: 'fr-ca'
			});
		});

		/* Birth date picker */
		_form.find('input[name=birthdate]').each(function(){
			var field = $(this);
			field.datetimepicker({
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				viewMode: 'years',
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			});
		});

		/* Service start date picker */
		_form.find('input[name=service_start_date]').each(function(){
			var field = $(this);
			field.datetimepicker({
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				viewMode: 'years',
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			});
		});

		/* Uploaders */
		_form.uploader.files = _form.find(".contact-files-upload").Uploader({
			parent: _form,
			model : 'contact',
			type: 'file',
			id : _form.get_contact_id(),
			multiple: true,
		});
		_form.uploader.notes = _form.find(".contact-notes-upload").Uploader({
			parent: _form,
			model : 'contact',
			type: 'note',
			id : _form.get_contact_id(),
			multiple: true,
		});

		_form.find('#field-user-auth_level').on('changed.bs.select change', _form.set_permissions);
		_form.set_permissions();
		_form.init_permissions();

		// Return
		return _form;
	}();
}
